export const isTenant = () => window.keycloak.hasResourceRole('Verbrauchs-App', 'kugu-portal');
export const isFullRemote = () => window.keycloak.hasResourceRole('Vollzugriff', 'kugu-portal');
export const isSmokeDetector = () => window.keycloak.hasResourceRole('Rauchmelder-Administration', 'kugu-portal');
export const isPropertyManager = () => window.keycloak.hasResourceRole('Hausverwaltung', 'kugu-portal');
